<template>
  <div id="newRequestMobile">

    <input :class="{invalid: $validate.error('request.title')}" type="text" v-model="request.title">
    <label for="">{{ $t("form.title") }}</label>
    <!--
    <input type="text" v-model="building" :class="{invalid: $validate.error('building')}">
    <label for="">{{ $t("address.building") }}</label>
    <input type="text" v-model="door" :class="{invalid: $validate.error('door')}">
    <label for="">{{ $t("address.unit") }}</label>
    -->
    <input :class="{invalid: $validate.error('request.phoneNumber')}" type="text" v-model="request.phoneNumber">
    <label for="">{{ $t("user.phone") }}</label>
    <div v-show="categories_lv1.length">
      <select :class="{invalid: $validate.error('category.lv1')}" id="selCategory1" v-model="category.lv1">
        <option :value="null">{{$t('requests.category.lv1_empty_text')}}...</option>
        <option :value="c.id" v-for="c of categories_lv1">{{$to(c.name)}}</option>
      </select>
      <label for="selCategory1">{{ $t("requests.category.lv1") }}</label>
    </div>
    <div v-show="categories_lv2.length">
      <select :class="{invalid: $validate.error('category.lv2')}" id="selCategory2" v-model="category.lv2">
        <option :value="null">{{$t('requests.category.lv2_empty_text')}}...</option>
        <option :value="c.id" v-for="c of categories_lv2">{{$to(c.name)}}</option>
      </select>
      <label for="selCategory2">{{ $t("requests.category.lv2") }}</label>
    </div>
    <div v-show="categories_lv3.length">
      <select :class="{invalid: $validate.error('category.lv3')}" id="selCategory3" v-model="category.lv3">
        <option :value="null">{{$t('requests.category.lv3_empty_text')}}...</option>
        <option :value="c.id" v-for="c of categories_lv3">{{$to(c.name)}}</option>
      </select>
      <label for="selCategory3">{{ $t("requests.category.lv3") }}</label>
    </div>

    <textarea :class="{invalid: $validate.error('request.body')}" cols="30" id="" name="" rows="10"
              v-model="request.body"></textarea>
    <label for="">{{ $t("form.comments_precision") }}</label>

    <FileUploader unique-key="mobile" @upload="setImageData" class="file"></FileUploader>

    <input id="chkUrgent" type="checkbox" v-model="request.emergency">
    <label for="chkUrgent">{{ $t("requests.urgent") }}</label>

    <input id="chkAbsent" type="checkbox" v-if="!property.commercial" v-model="request.canAccessIfAbsent">
    <label for="chkAbsent" v-if="!property.commercial">{{ $t("requests.absent") }}</label>

    <input id="chkAlarm" type="checkbox" v-if="property.commercial" v-model="request.alarm">
    <label for="chkAlarm" v-if="property.commercial">{{ $t("requests.alarm") }}</label>

    <input :class="{invalid: $validate.error('request.alarmCode')}" type="text" v-if="request.alarm"
           v-model="request.alarmCode">
    <label for="" v-if="request.alarm">{{ $t("requests.alarmCode") }}</label>

    <input id="chkAnimal" type="checkbox" v-if="!property.commercial" v-model="request.animal">
    <label for="chkAnimal" v-if="!property.commercial">{{ $t("requests.animal") }}</label>

    <div v-if="request.animal">{{ $t("requests.animal_warning") }}</div>

    <div class="buttons">
      <div @click="back" class="btn btn-secondary">{{ $t("navigation.back") }}</div>
      <div @click="send" class="btn btn-primary">{{ $t("navigation.send") }}</div>
    </div>

  </div>
</template>

<script>
  import FileUploader from "../../components/FileUploader";

  export default {
    name: "newRequestMobile",
    props: {

      request: Object,
      property: Object,
      category: Object,

      categories_lv1: Array,
      categories_lv2: Array,
      categories_lv3: Array,

      back: Function,
      send: Function,
      setImageData: Function
    },

    components: {
      FileUploader
    },

    watch: {
      'category.lv1'() {
        this.category.lv2 = undefined
      },
      'category.lv2'() {
        this.category.lv3 = undefined
      }
    },

    validate: {
      "request.title": {required: true},
      "request.body": {required: true},
      // building: {required: true},
      // door: {required: true},
      "request.phoneNumber": {required: true, phone: true},
      "request.alarmCode": {
        required: true, condition: function () {
          return !!this.alarm;
        }
      },
      'category.lv1': {
        required: true,
        condition: function () {
          return this.categories_lv1.length > 0
        }
      },
      'category.lv2': {
        required: true,
        condition: function () {
          return this.categories_lv2.length > 0
        }
      },
      'category.lv3': {
        required: true,
        condition: function () {
          return this.categories_lv3.length > 0
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  #newRequestMobile {
    padding: 20px;
  }

  input, textarea, select {
    width: 100%;
  }

  .buttons {
    display: flex;
    margin-top: 40px;

    .btn {
      flex-grow: 1;
      flex-basis: 0;

      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  textarea + label {
    margin-bottom: 0px;
  }

  input[type=checkbox] + label {
    margin-bottom: 20px;
  }

  .file {
    top: -15px;
  }
</style>